<template>
  <section class="statement-section">
    <div class="statement-section__header">
      <div class="statement-section__marker">1</div>
      <div>
        <h3 class="statement-section__title">Личные данные</h3>
        <p class="statement-section__description">
          Основная информация об абитуриенте
        </p>
      </div>
    </div>

    <div class="statement-fields">
      <v-text-field autocomplete="one-time-code" :model-value="formData.lastname" :rules="requiredNameRules" variant="outlined"
        density="comfortable" required @update:model-value="value => $emit('update-name', 'lastname', value)">
        <template #label>
          Фамилия <span class="statement-required">*</span>
        </template>
      </v-text-field>
      <v-text-field autocomplete="one-time-code" :model-value="formData.firstname" :rules="requiredNameRules" variant="outlined"
        density="comfortable" required @update:model-value="value => $emit('update-name', 'firstname', value)">
        <template #label>
          Имя <span class="statement-required">*</span>
        </template>
      </v-text-field>
      <v-text-field autocomplete="one-time-code" :model-value="formData.patronymic" :rules="optionalNameRules" label="Отчество" variant="outlined"
        density="comfortable" @update:model-value="value => $emit('update-name', 'patronymic', value)" />

      <v-radio-group v-model="formData.gender" class="statement-radio-group" inline>
        <template #label>
          Пол <span class="statement-required">*</span>
        </template>
        <v-radio label="Мужской" value="male" />
        <v-radio label="Женский" value="female" />
      </v-radio-group>

      <div class="statement-inline-fields statement-inline-fields--personal">
        <v-text-field autocomplete="one-time-code"
          :model-value="formData.snils"
          variant="outlined"
          density="comfortable"
          :rules="snilsRules"
          maxlength="14"
          :required="snilsRequired"
          @update:model-value="value => $emit('update-snils', value)"
        >
          <template #label>
            СНИЛС <span v-if="snilsRequired" class="statement-required">*</span>
          </template>
        </v-text-field>

        <v-text-field autocomplete="one-time-code" v-model="formData.birthDate" class="statement-date-field" type="date" variant="outlined"
          density="comfortable" :min="birthDateMin" :max="birthDateMax" :rules="birthDateRules" required>
          <template #label>
            Дата рождения <span class="statement-required">*</span>
          </template>
        </v-text-field>
      </div>

      <div class="statement-inline-fields statement-inline-fields--personal">
        <v-text-field autocomplete="one-time-code"
          v-model="formData.email"
          type="email"
          variant="outlined"
          density="comfortable"
          :rules="emailRules"
          :required="emailRequired"
        >
          <template #label>
            Email <span v-if="emailRequired" class="statement-required">*</span>
          </template>
        </v-text-field>

        <v-text-field autocomplete="one-time-code"
          :model-value="formData.phone"
          variant="outlined"
          density="comfortable"
          :rules="phoneRules"
          maxlength="16"
          required
          @update:model-value="value => $emit('update-phone', value)"
        >
          <template #label>
            Телефон <span class="statement-required">*</span>
          </template>
        </v-text-field>
      </div>

      <v-select autocomplete="one-time-code" v-model="formData.citizenshipType" :items="$model.citizenshipTypes" item-title="name"
        item-value="id" variant="outlined" density="comfortable" required>
        <template #label>
          Тип гражданства <span class="statement-required">*</span>
        </template>
      </v-select>

      <v-autocomplete autocomplete="one-time-code" v-model="formData.citizenship" :items="$model.countries" item-title="name"
        item-value="code" variant="outlined" density="comfortable" clearable required>
        <template #label>
          Гражданство <span class="statement-required">*</span>
        </template>
      </v-autocomplete>

      <v-text-field autocomplete="one-time-code" v-model="formData.birthPlace" variant="outlined" density="comfortable" required>
        <template #label>
          Место рождения <span class="statement-required">*</span>
        </template>
      </v-text-field>

      <v-select autocomplete="one-time-code" v-model="formData.socialStatus" :items="socialStatusOptions" item-title="label"
        item-value="value" label="Социальный статус поступающего" variant="outlined" density="comfortable" />

      <div v-if="$model.isStaff" class="statement-inline-fields statement-inline-fields--personal">
        <v-checkbox v-model="formData.submittedViaEpgu"
          label="Заявление подано через ЕПГУ" hide-details />

        <v-text-field v-if="formData.submittedViaEpgu" autocomplete="one-time-code" v-model="formData.eserviceNumber" label="Номер заявления"
          variant="outlined" density="comfortable" :disabled="!formData.submittedViaEpgu" hide-details="auto" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonalSection',
  emits: ['update-name', 'update-snils', 'update-phone'],
  props: {
    formData: {
      type: Object,
      required: true
    },
    birthDateMin: {
      type: String,
      required: true
    },
    birthDateMax: {
      type: String,
      required: true
    },
    birthDateRules: {
      type: Array,
      required: true
    },
    requiredNameRules: {
      type: Array,
      required: true
    },
    optionalNameRules: {
      type: Array,
      required: true
    },
    snilsRules: {
      type: Array,
      required: true
    },
    emailRules: {
      type: Array,
      required: true
    },
    phoneRules: {
      type: Array,
      required: true
    },
    snilsRequired: {
      type: Boolean,
      default: true
    },
    emailRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      socialStatusOptions: [
        { value: 0, label: '-' },
        { value: 1, label: 'Сирота' },
        { value: 2, label: 'Опекаемый' }
      ]
    }
  }
}
</script>
